<template>
  <section v-if="items.length" class="entity-media-attrs">
    <SectionTitle title="媒体属性" />
    <div
      v-for="item in items"
      :key="item.label"
      class="entity-media-attrs__block"
    >
      <h4 class="entity-media-attrs__label">{{ item.label }}</h4>
      <div class="entity-media-attrs__grid">
        <img
          v-for="(url, index) in item.imageUrls"
          :key="`${item.label}-${index}`"
          :src="url"
          :alt="item.label"
        />
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from './SectionTitle.vue'

export default {
  name: 'EntityMediaAttributes',
  components: { SectionTitle },
  props: {
    items: { type: Array, default: () => [] }
  }
}
</script>

<style lang="scss" scoped>
.entity-media-attrs {
  margin-bottom: $spacing-3xl;

  &__block {
    margin-bottom: $spacing-xl;
    padding: $spacing-base;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);
  }

  &__label {
    font-size: rem(15);
    font-weight: 600;
    color: $color-brown-dark;
    margin-bottom: $spacing-base;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: $spacing-sm;

    img {
      width: 100%;
      height: 140px;
      object-fit: cover;
      border-radius: 4px;
      filter: grayscale(0.2) sepia(0.1);
    }
  }
}
</style>
